import React from 'react';
import { Box } from '@mui/material';
import { LayoutSlots } from '../types';

interface Props<Context extends any = any> extends LayoutSlots<Context> {
  context: Context;
  table: React.ReactNode;
}

export const Layout = <Context extends any = any>({
  table,
  context,
  actionPanelTop,
  ActionPanelTop,
  ActionPanelBottom,
  actionPanelBottom,
}: Props<Context>) => {
  return (
    <Box sx={{ display: 'grid', gridTemplateRows: 'auto 1fr auto', height: '100%', gap: '0.5rem' }}>
      {ActionPanelTop && <ActionPanelTop context={context} />}
      {actionPanelTop && actionPanelTop({ context })}
      {table}
      {actionPanelBottom && actionPanelBottom({ context })}
      {ActionPanelBottom && <ActionPanelBottom context={context} />}
    </Box>
  );
};
